import { EntityRepository, Repository } from 'typeorm';
import { GameAction } from '../entities/Common/GameAction.entity';

@EntityRepository(GameAction)
export class GameFlowRepository extends Repository<GameAction> {}
